'use client';

import React, { type FC } from 'react';
import type { ColorTypeModel, SizeType } from '../../models';

import Spinner, { type SpinnerColorTypeModel } from './Spinner';

const spinnerSizeThemes = {
  xs: 'w-3 h-3',
  sm: 'w-3 h-3',
  base: 'w-4 h-4',
  lg: 'w-4 h-4',
  xl: 'w-4 h-4',
};

const buttonColorSpinnerColorMap: Record<
  ColorTypeModel,
  SpinnerColorTypeModel
> = {
  primary: 'secondary',
  secondary: 'white',
  white: 'gray',
  gray: 'gray',
  coolGray: 'gray',
  yellow: 'secondary',
};

interface Props {
  size: SizeType;
  colorType: ColorTypeModel;
}

const ButtonSpinner: FC<Props> = ({ size, colorType }) => {
  return (
    <div className={`m-[2px] ${spinnerSizeThemes[size]}`}>
      <Spinner colorType={buttonColorSpinnerColorMap[colorType]} />
    </div>
  );
};

export default ButtonSpinner;
